/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

    // Dashboard
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:rectangle-group',
        link : '/dashboard',
    },

    // Projects
    {
        id   : 'project-management.projects',
        title: 'Projects',
        type : 'basic',
        icon : 'mat_outline:bubble_chart',
        link : '/project-management/projects',
    },

    // Customers. Its own item since the 30 Sep 2026 menu rejig, no longer under Sales. The id keeps
    // its `crm.` prefix so the customersView gate and the CRM_Contacts feature switch still find it.
    {
        id   : 'crm.contacts',
        title: 'Customers',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/crm/contacts',
    },

    // CRM (Sales)
    {
        id      : 'crm',
        title   : 'Sales',
        type    : 'collapsable',
        icon    : 'custom:money',
        children: [

            // Sales Pipeline
            {
                id   : 'crm.pipeline',
                title: 'Sales Pipeline',
                type : 'basic',
                icon : 'heroicons_outline:presentation-chart-line',
                link : '/crm/pipeline',
            },

            // Lead Management
            {
                id   : 'crm.leads',
                title: 'Lead Management',
                type : 'basic',
                icon : 'feather:user',
                link : '/crm/leads',
            },

            // Sales Orders
            // {
            //     id   : 'crm.sales-orders',
            //     title: 'Sales Orders',
            //     type : 'basic',
            //     icon : 'mat_outline:shopping_cart',
            //     link : '/crm/sales-orders',
            // },

            // Email Marketing
            {
                id   : 'crm.emails',
                title: 'Emails',
                type : 'basic',
                icon : 'heroicons_outline:at-symbol',
                link : '/crm/emails',
            },

        ],
    },

    //Marine Sales. Bought in and resold: its own order board and settings, and a marine view of the
    //MAIN part register (DLM, 2026-09-29: marine parts are register parts, vendors are suppliers).
    //Dotted ids so `marine` in navigation-access.ts covers the group; settings names its own.
    {
        id      : 'marine',
        title   : 'Marine Sales',
        type    : 'collapsable',
        icon    : 'feather:anchor',
        children: [
            // Order and names are Dave's (2026-09-21): the board first, it is where the day is spent.
            {
                id   : 'marine.orders',
                title: 'Marine Sales Board',
                type : 'basic',
                link : '/marine/orders',
            },
            {
                id   : 'marine.parts',
                title: 'Marine Part Register',
                type : 'basic',
                link : '/marine/parts',
            },
            {
                id   : 'marine.settings',
                title: 'Marine Settings',
                type : 'basic',
                link : '/marine/settings',
            },
        ]
    },

    // Hire
    {
        id      : 'hire',
        title   : 'Hire',
        type    : 'collapsable',
        icon    : 'heroicons_outline:truck',
        children: [
            // Dashboard
            {
                id   : 'hire.dashboard',
                title: 'Hire Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-group',
                link : '/hire/dashboard',
            },
            // Dashboard
            {
                id   : 'hire.asset-board',
                title: 'Asset Board',
                type : 'basic',
                icon : 'heroicons_outline:view-columns',
                link : '/hire/asset-board',
            },
            // Customers
            // {
            //     id   : 'hire.customers',
            //     title: 'Customers',
            //     type : 'basic',
            //     icon : 'heroicons_outline:user-group',
            //     link : '/hire/customers',
            // },
            // Calendar
            {
                id   : 'hire.calendar',
                title: 'Calendar',
                type : 'basic',
                icon : 'heroicons_outline:calendar-days',
                link : '/hire/calendar',
            },
            // Assets
            {
                id   : 'hire.assets',
                title: 'Asset Register',
                type : 'basic',
                icon : 'heroicons_outline:cube-transparent',
                link : '/hire/assets',
            },
            // Hire Orders
            {
                id   : 'hire.hire-orders',
                title: 'Hire Orders',
                type : 'basic',
                icon : 'mat_outline:shopping_cart',
                link : '/hire/hire-orders',
            },
            // Reporting
            {
                id   : 'crm.reporting',
                title: 'Reporting',
                type : 'basic',
                icon : 'feather:bar-chart-2',
                link : '/crm/reporting',
            },
        ],
    },

    // Calibrations
    {
        id      : 'calibration',
        title   : 'Calibration',
        type    : 'collapsable',
        icon    : 'heroicons_outline:wrench-screwdriver',
        children: [
            //     'My Dashboard'
            {
                id   : 'calibration.my-dashboard',
                title: 'My Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-group',
                link : '/calibration/my-dashboard',
            },
            //     Admin Dashboard
            {
                id   : 'calibration.admin-dashboard',
                title: 'Admin Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:squares-2x2',
                link : '/calibration/dashboard/admin-dashboard',
            },
            //     Engineer Dashboard
            {
                id   : 'calibration.engineer-dashboard',
                title: 'Engineer Dashboard',
                type : 'basic',
                icon : 'mat_outline:dashboard',
                link : '/calibration/dashboard/engineer-dashboard',
            },
            //     Workshop Dashboard
            {
                id   : 'calibration.workshop-dashboard',
                title: 'Workshop',
                type : 'basic',
                icon : 'mat_outline:home_repair_service',
                link : '/calibration/dashboard/workshop-dashboard',
            },
            //     Servicing
            {
                id   : 'calibration.servicing',
                title: 'Servicing',
                type : 'basic',
                icon : 'heroicons_outline:wrench',
                link : '/calibration/servicing',
            },
            //      Calibration Settings
            {
                id   : 'calibration.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/calibration/settings',
            },
        ],
    },

    //Engineering (30 Sep 2026 menu rejig).
    {
        id      : 'engineering',
        title   : 'Engineering',
        type    : 'collapsable',
        icon    : 'mat_outline:architecture',
        children: [
            //     BOMs. A deep link into the Product Register's BOM panel, but given its own
            //     entry because a BOM list is somewhere people go directly, not something they
            //     should have to reach by opening the register and switching panel
            //     (Dave, 2026-08-18).
            {
                id   : 'boms',
                title: 'BOMs',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-group',
                link : '/product-register/bom',
            },

            //     Change Notes. A placeholder page until DLM send the spec.
            {
                id   : 'change-notes',
                title: 'Change Notes',
                type : 'basic',
                icon : 'heroicons_outline:pencil-square',
                link : '/change-notes',
            },
        ]
    },

    //Suppliers
    {
        id   : 'suppliers',
        title: 'Suppliers',
        type : 'basic',
        icon : 'custom:suppliers',
        link : '/suppliers',
    },

    //Inventory
    {
        id      : 'inventory',
        title   : 'Inventory',
        type    : 'collapsable',
        icon    : 'feather:clipboard',
        children: [
            //     Part Register
            {
                id   : 'part-register',
                title: 'Part Register',
                type : 'basic',
                icon : 'mat_outline:list_alt',
                link : '/part-register',
            },

            //     Product Register
            //     exactMatch so it does not also light up when the BOMs entry (a deep link into
            //     this same route) is the active one.
            {
                id        : 'product-register',
                title     : 'Product Register',
                type      : 'basic',
                icon      : 'heroicons_outline:clipboard-document-list',
                link      : '/product-register',
                exactMatch: true,
            },

            //     Stock pages (30 Sep 2026 menu rejig): Part Register panels until then, their own
            //     pages now. Labels are the prototype's. Dotted ids so `stock` in
            //     navigation-access.ts covers the group.
            {
                id      : 'stock',
                title   : 'Stock Notification and settings',
                type    : 'collapsable',
                icon    : 'heroicons_outline:bell-alert',
                children: [
                    { id: 'stock.history',        title: 'Stock History',           type: 'basic', icon: 'heroicons_outline:clock',              link: '/stock/history' },
                    { id: 'stock.alerts',         title: 'Stock Alerts',            type: 'basic', icon: 'feather:alert-triangle',               link: '/stock/alerts' },
                    { id: 'stock.overrides',      title: 'Override Audit Log',      type: 'basic', icon: 'feather:repeat',                       link: '/stock/overrides' },
                    { id: 'stock.locations',      title: 'Bin & Rack Management',   type: 'basic', icon: 'heroicons_outline:map-pin',            link: '/stock/locations' },
                    { id: 'stock.adjustments',    title: 'Adjustments & Transfers', type: 'basic', icon: 'heroicons_outline:scale',              link: '/stock/adjustments' },
                    { id: 'stock.cycle-counting', title: 'Cycle Counting',          type: 'basic', icon: 'mat_outline:refresh',                  link: '/stock/cycle-counting' },
                    //     Stock Reserves HIDDEN (Dave, 2026-10-01): work orders now allocate their own
                    //     stock, so a manual reservation no longer reduces Available. Route kept live
                    //     (/stock/reservations) so old reservations can still be looked at.
                    // { id: 'stock.reservations',   title: 'Stock Reserves',          type: 'basic', icon: 'heroicons_outline:lock-closed',        link: '/stock/reservations' },
                    { id: 'stock.replenishment',  title: 'Replenishments',          type: 'basic', icon: 'heroicons_outline:arrow-path',         link: '/stock/replenishment' },

                    //     Stock Settings: who hears about low stock and quarantined parts. Last in
                    //     the group, as settings should be (Dave, 2026-10-01). Deliberately NOT a
                    //     `stock.` id: it keeps its own, stricter stock.manage gate instead of
                    //     inheriting the group's.
                    { id: 'stock-settings',       title: 'Stock Settings',          type: 'basic', icon: 'heroicons_outline:cog-6-tooth',        link: '/stock-settings' },
                ]
            },
        ]
    },

    //Purchasing
    {
        id      : 'purchasing',
        title   : 'Purchasing',
        type    : 'collapsable',
        icon    : 'heroicons_outline:shopping-cart',
        children: [
            //     Purchase Orders
            {
                id   : 'purchase-orders',
                title: 'Purchase Orders',
                type : 'basic',
                icon : 'mat_outline:list_alt',
                link : '/purchase-orders',
            },
            //     Purchasing rules: the PO auto-approve limit + who may approve above it.
            //     Needs purchasing.settings: the item (navigation-access.ts), the route (app.routes.ts)
            //     and the endpoints all ask for it.
            {
                id   : 'purchase-order-settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-6-tooth',
                link : '/purchase-order-settings',
            },
        ]
    },

    //     Invoicing. Its own item since the 30 Sep 2026 menu rejig, lifted out of Hire. Still the
    //     hire invoicing screen, so the id stays `hire.invoicing`: the hireView gate and the
    //     HIRE_Invoicing feature switch keep applying until it is decided what it should become.
    {
        id   : 'hire.invoicing',
        title: 'Invoicing',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/hire/invoicing',
    },

    //     Sales Orders
    // /sales-orders now serves the V2 screen as its own page; V1 moved to
    // /sales-orders-legacy (Dave, 2026-07-29). The link itself is unchanged.
    {
        id   : 'sales-orders',
        title: 'Sales Orders',
        type : 'basic',
        icon : 'mat_outline:list_alt',
        link : '/sales-orders',
    },

    //     Internal Stock Orders (DLMIO) - auto-raised from approved BOMs. WIP: visibility gating
    //     for DLM users is an open decision (see slice 3 notes); nav is static here so true per-user
    //     hiding needs a chosen mechanism.
    {
        id   : 'internal-stock-orders',
        title: 'Internal Stock Orders',
        type : 'basic',
        icon : 'mat_outline:inventory_2',
        link : '/internal-stock-orders',
    },

    //Production
    {
        id: 'production',
        title: 'Production',
        type: 'basic',
        icon: 'mat_outline:construction',
        link: '/production',
    },

    //Goods in/out (30 Sep 2026 menu rejig). These were Part Register panels; they are their own
    //pages now. Dotted ids so `goods` in navigation-access.ts covers the group.
    {
        id      : 'goods',
        title   : 'Goods in/out',
        type    : 'collapsable',
        icon    : 'heroicons_outline:cube',
        children: [
            {
                id   : 'goods.in',
                title: 'Goods In',
                type : 'basic',
                icon : 'feather:truck',
                link : '/goods/in',
            },
            {
                id   : 'goods.quarantine',
                title: 'Quarantine Area',
                type : 'basic',
                icon : 'heroicons_outline:shield-exclamation',
                link : '/goods/quarantine',
            },
            {
                id   : 'goods.returns',
                title: 'Returns',
                type : 'basic',
                icon : 'heroicons_outline:arrow-uturn-left',
                link : '/goods/returns',
            },
        ]
    },

    //Admin
    {
        id      : 'admin',
        title   : 'Admin',
        type    : 'collapsable',
        icon    : 'heroicons_outline:identification',
        children: [

            //     HR
            {
                id   : 'hr',
                title: 'HR',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/hr',
            },

            //     Reports
            {
                id   : 'reports',
                title: 'Reports',
                type : 'basic',
                icon : 'mat_outline:insert_chart',
                link : '/reports',
            },

            //     Form Builder
            {
                id   : 'form-builder',
                title: 'Form Builder',
                type : 'basic',
                icon : 'mat_outline:build_circle',
                link : '/form-builder',
            },
        ],
    },

    //     Clock In/Out
    {
        id   : 'calibration.clocking-in',
        title: 'Clocking in/out',
        type : 'basic',
        icon : 'custom:clock-in',
        link : '/calibration/clocking-in',
    },

    //     Help Center
    {
        id   : 'help-center',
        title: 'Help Center',
        type : 'basic',
        icon : 'heroicons_outline:question-mark-circle',
        link : '/help-center',
    },

    // Settings
    {
        id      : 'settings',
        title   : 'Settings',
        type    : 'basic',
        icon    : 'heroicons_outline:cog-8-tooth',
        link    : '/settings',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        tooltip : 'Dashboard',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        tooltip : 'Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        tooltip : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'DASHBOARDS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'APPS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id   : 'others',
        title: 'OTHERS',
        type : 'group',
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        type    : 'group',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'group',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
